import { kickUrlParam } from "@/common/utils.js";
import { downloadFileDirect } from "@/common/file.js";
import { verifyLogin } from "@/common/auth.js";
import { ck, URLS } from "fire-wind-water";
import { isSetting } from "@/common/sbase.js";
import { fileData as mockFileData } from "@/mock/file.js";
import wechat from "@/common/wechat.js";
import { getGlobalUserId } from "@/../stempcore/src/core/client.js";
import { isInWechatAuth, initJsSdk, agentType} from "@/../stempcore/src/sbase";
import URL from "../assets/conf/setting.json";

import {
  timestampToDateStr,
  copyToClipboard,
  bytesToSize
} from "@/common/utils.js";
import { extentionMapFilter, getPreviewUrl } from "@/common/file.js";
import cs from "@/services/commonService.js";
// import $ from 'jquery'

const publicPath = process.env.BASE_URL;
if (!isSetting) {
    window.$sk && window.$sk.loading.show();
}

const mixin = {
  props: ["fileId"],
  data() {
    return {
      publicPath,
      clientType: window.$ua.clientType,
      accKey: URLS.getURL("accKey"),
      config: URLS.getURL("configId"),
      weChatId: URLS.getURL("weChatId"),
      // fileData: {}
      isSetting: isSetting,
      defaultRess: {
        pc: {
          logo: publicPath + "images/template/logo-default.png",
          banner: publicPath + "images/template/banner-default.png",
          fileCover: publicPath + "images/template/file-cover-default.png"
        },
        wap: {
          logo: publicPath + "images/template/logo-m-default.png",
          banner: publicPath + "images/template/banner-m-default.png",
          fileCover: publicPath + "images/template/file-m-cover-default.png"
        }
      },
      showLoading: false,
      fileData: {},
      noLogin: true,
      // 复制链接
      showCopyUrlPrompt: false,
      copyUrl: "",
      ctaObj:{
        objId:'',
        tenantId:'',
        moduleId:'12'
      }
    };
  },
  computed: {
    downloadUrl() {
      return decodeURIComponent(this.GetUrlParam("downloadUrl"));
    }
  },
  methods: {

    skUserEnd() {
      console.log("获取用户信息结束");
      const info = window.$sk.template.get();
      this.schemaId = info.common.schemaId;

      this.loadFileData(this.schemaId);
      //      this.contactInfo = info.user;
      //      this.moduleId = info.common.moduleId;
      //      this.getData();
    },
    onPreview(file, noLogin) {
      //this.interactionPreview(file, 'b');
      if (this.isSetting) return;

      if (['other', 'flv'].indexOf(file.extType) > -1) {
        this.$antMessage.warning("该文件不支持预览");
        return;
      }
      if (file.previewUrl == "") {
        this.$antMessage.warning("未获取到文件地址");
        return;
      }



      if (noLogin && (file.previewType == '1' || file.previewType == '3')) {
        this.verifyPermission(file);
        return;
      }
      let {href} = this.$router.resolve({
        path: `/${this.platform}/filePreview`,
        query: {
          fileId: file.fileId
        }
      });
      let urlHref = window.location.href.split('#')[0] + href;
      window.open(urlHref);
    },
    // 文件下载
    onDownloadFile(file, downloadType) {
      debugger;
      if (this.isSetting) return;
      console.log("# onFileDownload");
      // 判断登录权限
      if (this.verifyPermission(file)) {
        this.handleFileDownload(file, downloadType);
      }
    },
    handleFileDownload(file, downloadType) {
      // console.log("# handleFileDownload");
      // console.log("# downloadType: ", downloadType);
      // 判断下载方式
      if (downloadType == 0) {
        // 0 邮件下载
        this.$emit("downloadByEmail", { file });
      } else {
        // 1 直接下载
        let downloadUrl =  kickUrlParam((file.downloadFileUrlWithUserInfo || file.downloadFileUrl || file.fileUrl), "isPreview");
        // 判断需要浏览器打开下载的环境
        let memberInfo = ck.cookie("smarketMember_" + file.schemaId);
        // 是否为IOS环境
        const isIOS = /(iPhone|iPad|iPod)/i.test(window.navigator.userAgent);
        // 非IOS的微信环境下，转入提示页面(浏览器打开)
        let val = {
          downloadUrl: downloadUrl,
          memberInfo: memberInfo
        };

        debugger;
        if (!isIOS && window.$ua.isWeChat && window.location.href.indexOf('wap') > -1) {
          this.showTips(val)
        } else {
          let markCode = URLS.getURL("markCode") || URLS.getHash("markCode");
          if (markCode !== null) {
            let newUrl = URLS.updateParam("markCode", markCode, downloadUrl);
            downloadFileDirect(newUrl);
          } else {
            downloadFileDirect(downloadUrl);
          }

        }
      }
    },

    // 访问验证
    verifyPermission(data) {
      console.log("# verifyPermission");
      // 权限验证
      // 判断是否需要登录
      if (data.identity == 3) {
        return verifyLogin(data);
      } else {
        return true;
      }
    },
    cookFileData(data) {
      let fileData = {};
      fileData.fileId = data.fileId;
      fileData.name = data.name;
      fileData.isRelease = data.isRelease;
      fileData.isReview = data.isReview; // 邮箱下载是否需要审核
      // fileData.reviewTaskId = data.reviewTaskId
      fileData.enableShare = data.enableShare;
      fileData.upperEnableShare = data.upperEnableShare;

      fileData.shareTitle = data.shareTitle;
      fileData.shareDesc = data.shareDesc;
      fileData.shareImageRealPath = data.shareImageRealPath;
      fileData.longUrlLink = data.longUrlLink;

      fileData.identity = data.identity;
      fileData.registerFormId = data.registerFormId;
      fileData.downloadType = data.downloadType;

      fileData.weChatId = data.weChatId;
      // fileData.bindWechatId = data.bindWechatId

      fileData.tenantId = data.tenantId;

      fileData.instanceId = data.instanceId;
      fileData.schemaId = data.schemaId;
      fileData.upperFileId = data.upperFileId;

      fileData.pcConfigId = data.pcConfigId;
      fileData.pcTemplateId = data.pcTemplateId;
      fileData.wapConfigId = data.wapConfigId;
      fileData.wapTemplateId = data.wapTemplateId;

      fileData.ext = data.ext;
      fileData.extType = extentionMapFilter(fileData.ext).type;
      fileData.descInfo = data.descInfo;
      fileData.previewType = data.preview.type;
      fileData.previewShow = data.preview.show;
      fileData.fileUrl = data.fileUrl;
      fileData.downloadFileUrl = data.downloadFileUrl;
      fileData.downloadFileUrlWithUserInfo = data.downloadFileUrlWithUserInfo;
      fileData.previewCount = data.statInfo.previewCount;
      fileData.downloadCount = data.statInfo.downloadCount;
      fileData.sizeText = bytesToSize(parseInt(data.size));
      fileData.dateText = timestampToDateStr(data.modifyTime * 1000);
      fileData.previewUrl = (("ppt,pdf".indexOf(fileData.extType) > -1)
                                ? data.previewUrl
                                : getPreviewUrl(fileData.extType, fileData.fileUrl))

      // 全局信息
      fileData.clientType = window.$ua.clientType;

      this.ctaObj.objId = fileData.fileId;;
      this.ctaObj.tenantId = fileData.tenantId;
      if (fileData.coverMapId && fileData.coverMapId !== "") {
        fileData.coverUrl =
          this.$conf.template.api.ungateway.contentUrl +
          "?mappingId=" +
          fileData.coverMapId;
      } else {
        fileData.coverUrl = this.defaultRess[this.platform].fileCover;
      }
      return fileData;
    },
    loadFileData(schemaId) {
      this.showLoading = true;
      let tokenInfo = ck.cookie("verifyInfo_" + this.weChatId);
      let memberInfo = ck.cookie("smarketMember_" + schemaId);
      this.service
        .getReleaseFile({
          // fileId: this.fileId
          fileId: this.fileId,
          globalUserId: ck.cookie("globalUserId"),
          weChatId: this.weChatId,
          openId: tokenInfo ? tokenInfo.original.openid : "",
          sess: memberInfo ? memberInfo.session : "",
          markCode:URLS.getURL("markCode") || URLS.getHash("markCode")
        })
        .subscribe(data => {
          this.showLoading = false;
          if (data.result !== 0) {
            this.$toast.fail("未获取到对应文件");
            console.log("未获取到对应文件");
            return;
          }
          let fileData = this.cookFileData(data.content);
          console.log("# fileData: ", fileData);
          this.$nextTick(() => {
            window.$sk.loading.hide();
          });
          this.fileData = fileData;
          this.initConfig(
            this.platform === "pc" ? fileData.pcConfigId : fileData.wapConfigId,
            fileData.tenantId
          );
          //          let weChatId = fileData.weChatId || this.weChatId;
          this.getWechatId(fileData).then(weChatId => {
            if (fileData.wechatId == 0) {
              fileData.weChatId = weChatId;
            }
            if(agentType() == 'weChat'){
              this.initWeChatShare();
            }else if(agentType() == 'wxWork'){
              initJsSdk(fileData.tenantId,()=>{
                this.initWxWorkShare();
              });
            }


            // 权限验证 详情页查看不做限制，下载时才有
            // this.verifyPermission(fileData);
            if (window.$ua.isWeChat && weChatId && isInWechatAuth(fileData.tenantId && false)) {//暂时不进去
              wechat.weChatLoad(fileData.tenantId, weChatId, true).then(
                () => {
                  // 获取用户联系信息
                  this.getContact(fileData);
                  // interactionPreview
                  this.interactionPreview(fileData);
                  this.fileData = fileData;
                },
                () => {
                  // 获取用户联系信息
                  this.getContact(fileData);
                  // interactionPreview
                  this.interactionPreview(fileData);
                  this.fileData = fileData;
                }
              );
            } else {
              // 获取用户联系信息
              this.getContact(fileData);
              // interactionPreview
              this.interactionPreview(fileData);
              this.fileData = fileData;
            }
          });
        });
    },
    // 获取联系信息
    getContact(fileData) {
      this.noLogin = verifyLogin(fileData,false) == false;
      if (ck.cookie("user_email")) return;
      let weChatId = fileData.weChatId || this.weChatId;
      let tokenInfo = ck.cookie("verifyInfo_" + weChatId);
      let memberInfo = ck.cookie("smarketMember_" + fileData.schemaId);
      this.service
        .getContact({
          globalUserId: ck.cookie("globalUserId"),
          tenantId: fileData.tenantId,
          weChatId: weChatId,
          openId: tokenInfo ? tokenInfo.original.openid : "",
          sess: memberInfo ? memberInfo.session : ""
        })
        .subscribe(data => {
          if (data.result == 0 && data.content.email) {
            ck.cookie("user_email", data.content.email);
          }
        });
    },
    // 记录预览行为
    interactionPreview(file, type) {
      let tokenInfo = ck.cookie("verifyInfo_" + file.weChatId);
      let memberInfo = ck.cookie("smarketMember_" + file.schemaId);
      let weChatId = file.weChatId || weChatId;
      let data = {
        tenantId: file.tenantId,
        fileId: file.fileId,
        source: window.$ua.clientType,
        globalUserId: ck.cookie("globalUserId"),
        sess: memberInfo ? memberInfo.session : "",
        openId: tokenInfo ? tokenInfo.original.openid : "",
        weChatId: weChatId ? weChatId : "",
        currentUrl: window.location.href,
        markCode: URLS.getURL("markCode") || URLS.getHash("markCode")
      };

      if (type == 'preview') {
        this.service.interactionPreview(data).subscribe(data => {
          // console.log(data);
          let status = data.content.status;
          if (status == 1) {
            console.log("# interaction preview: sucess.");
          } else {
            console.log("# interaction preview: error.");
          }
        });
      } else {
        this.service.interactionBrowse(data).subscribe(data => {
          // console.log(data);
          let status = data.content.status;
          if (status == 1) {
            console.log("# interaction preview: sucess.");
          } else {
            console.log("# interaction preview: error.");
          }
        });
      }



    },

    initWxWorkShare(){
      const url = URLS.removeSearchParam(
        window.location.href,
        "token",
        "retCode",
        "puzzleFlag"
      )
      const info = this.fileData;
      const shareInfo = {
        title: info.shareTitle || info.name, // 分享标题,
        desc: info.shareDesc || info.descInfo, // 分享描述,
        link: URL.weworkCustomerJumpUrl.replace('{$tenantId}',info.tenantId)+ encodeURIComponent(url),//这里需要改
        imgUrl: info.shareImageRealPath
          ? "https:" + info.shareImageRealPath
          : "", // 分享图标
      };
      shareInfo.link = window.$swxsdk.urlAddChannel(shareInfo.link);
      window.wx.onMenuShareAppMessage({...shareInfo});
      window.wx.onMenuShareWechat({...shareInfo});
      window.wx.onMenuShareTimeline({...shareInfo});
    },

    // 微信
    initWeChatShare() {
      const url = URLS.removeSearchParam(
        window.location.href,
        "token",
        "retCode",
        "puzzleFlag"
      )
      const info = this.fileData;
      const shareInfo = {
        title: info.shareTitle || info.name, // 分享标题,
        desc: info.shareDesc || info.descInfo, // 分享描述,
        link: URLS.updateSearchParam('return_url',encodeURIComponent(url),info.longUrlLink),
        imgUrl: info.shareImageRealPath
          ? "https:" + info.shareImageRealPath
          : "", // 分享图标
      };
      window.$swxsdk.initWxSdk({ tenantId: info.tenantId }, window.$sk.config.apiUrl);
      console.log('info.enableShare====' + info.enableShare);
      if (info.enableShare == 2) { //与父级保存一致
          if (info.upperEnableShare == 1) { //父级允许
            window.$swxsdk.on("sharer", shareInfo);
            window.$swxsdk.on("sharer_friends", shareInfo);
          } else {
            window.$swxsdk.on(
              "hideMenuList",
              {
                menuList: [
                  "menuItem:share:appMessage",
                  "menuItem:share:timeline",
                  "menuItem:share:qq",
                  "menuItem:share:weiboApp",
                  "menuItem:share:facebook",
                  "menuItem:share:QZone",
                  "menuItem:copyUrl",
                  "menuItem:openWithQQBrowser",
                  "menuItem:openWithSafari",
                  "menuItem:favorite"
                ]
              },
              function(result) {
                console.log(result);
              }
            );
            window.$swxsdk.on("hideOptionMenu");
            console.log('hideOptionMenu---434');
          }
      } else if (info.enableShare == 1) {
        window.$swxsdk.on("sharer", shareInfo);
        window.$swxsdk.on("sharer_friends", shareInfo);
      } else {
        window.$swxsdk.on(
          "hideMenuList",
          {
            menuList: [
              "menuItem:share:appMessage",
              "menuItem:share:timeline",
              "menuItem:share:qq",
              "menuItem:share:weiboApp",
              "menuItem:share:facebook",
              "menuItem:share:QZone",
              "menuItem:copyUrl",
              "menuItem:openWithQQBrowser",
              "menuItem:openWithSafari",
              "menuItem:favorite"
            ]
          },
          function(result) {
            console.log(result);
          }
        );

        window.$swxsdk.on("hideOptionMenu");
        console.log('hideOptionMenu---462');
      };

    },
    // 复制链接
    onCopyUrlPrompt({ url }) {
      console.log("# onCopyUrlPrompt..");
      this.showCopyUrlPrompt = true;
      this.copyUrl = url;
    },
    onConfirmCopy() {
      copyToClipboard(this.copyUrl);
      this.$toast("复制成功");
      this.copyUrl = "";
    },
    initMock() {
      this.fileData = mockFileData;
      //   this.$store.commit("setFileData", mockFileData);
    },
    getWechatId(fileData) {
      return new Promise(resolve => {
        let weChatId = fileData.weChatId || this.weChatId || 0;
        if (weChatId != 0) {
          resolve(weChatId);
        } else {
          cs.getDefWeChat({}).subscribe(data => {
            resolve(data.content.weChatId);
          });
        }
      });
    },
    showTips(val) {
      this.$router.push({
        path: "/wap/tips",
        query: {
          downloadUrl: val.downloadUrl,
          fs: val.memberInfo ? encodeURIComponent(val.memberInfo.session) : ""
        }
      });
      // if (val) {
      //   if (val.memberInfo.session) {
      //     const url = window.location.href +
      //       "&downloadUrl=" +
      //       encodeURIComponent(val.downloadUrl) +
      //       "&fs=" +
      //       encodeURIComponent(val.memberInfo.session);
      //     window.$sk.goto(url);
      //   } else {
      //     const url = window.location.href +
      //       "&downloadUrl=" + encodeURIComponent(val.downloadUrl);
      //     window.$sk.goto(url);
      //   }
      // } else {
      //   const url = window.location.href.substring(
      //     0,
      //     window.location.href.indexOf("&downloadUrl=")
      //   );
      //   window.$sk.goto(url);
      // }
    },
    GetUrlParam(paraName) {
      let url = document.location.toString();
      let arrObj = url.split("?");

      if (arrObj.length > 1) {
        let arrPara = arrObj[1].split("&");
        let arr;

        for (let i = 0; i < arrPara.length; i++) {
          arr = arrPara[i].split("=");

          if (arr != null && arr[0] == paraName) {
            return arr[1];
          }
        }
        return "";
      } else {
        return "";
      }
    }
  },
  created() {
    if (!ck.cookie("globalUserId")) {
      getGlobalUserId(); // 生成匿名用户
    }
    if (this.isSetting) {
      console.log("# isSetting...");
      this.initMock();
      return;
    }
    window.$sk.template.module(this);
    window.$sk && window.$sk.loading.show();

    let fs = decodeURIComponent(this.GetUrlParam("fs"));
    if (this.downloadUrl && !window.$ua.isWeChat) {
      if (fs) {
        ck.cookie("fileSession", fs, {
          domain: "smarket.net.cn",
          path: "/"
        });
      }
      downloadFileDirect(this.downloadUrl);
    }
  },


};

export default mixin;
